import gaEventTracker, { events } from "util/gaEventTracker";

export const types = {
    AFIP_FORM_LIST_REQUEST: "afip/AFIP_FORM_LIST_REQUEST",
    AFIP_FORM_LIST_FAILURE: "afip/AFIP_FORM_LIST_FAILURE",
    AFIP_FORM_LIST_SUCCESS: "afip/AFIP_FORM_LIST_SUCCESS",

    AFIP_FORM_FIELDS_REQUEST: "afip/AFIP_FORM_FIELDS_REQUEST",
    AFIP_FORM_FIELDS_FAILURE: "afip/AFIP_FORM_FIELDS_FAILURE",
    AFIP_FORM_FIELDS_SUCCESS: "afip/AFIP_FORM_FIELDS_SUCCESS",

    AFIP_FORM_FIELDS_CODES_REQUEST: "afip/AFIP_FORM_FIELDS_CODES_REQUEST",
    AFIP_FORM_FIELDS_CODES_FAILURE: "afip/AFIP_FORM_FIELDS_CODES_FAILURE",
    AFIP_FORM_FIELDS_CODES_SUCCESS: "afip/AFIP_FORM_FIELDS_CODES_SUCCESS",

    AFIP_TAX_FORMS_REQUEST: "afip/AFIP_TAX_FORMS_REQUEST",
    AFIP_TAX_FORMS_FAILURE: "afip/AFIP_TAX_FORMS_FAILURE",
    AFIP_TAX_FORMS_SUCCESS: "afip/AFIP_TAX_FORMS_SUCCESS",

    AFIP_BAR_CODE_REQUEST: "afip/AFIP_BAR_CODE_REQUEST",
    AFIP_BAR_CODE_FAILURE: "afip/AFIP_BAR_CODE_FAILURE",
    AFIP_BAR_CODE_SUCCESS: "afip/AFIP_BAR_CODE_SUCCESS",

    AFIP_PAYMENT_PREPARE_REQUEST: "afip/AFIP_PAYMENT_PREPARE_REQUEST",
    AFIP_PAYMENT_PREPARE_FAILURE: "afip/AFIP_PAYMENT_PREPARE_FAILURE",
    AFIP_PAYMENT_PREPARE_SUCCESS: "afip/AFIP_PAYMENT_PREPARE_SUCCESS",

    AFIP_PAYMENT_CONFIRM_REQUEST: "afip/AFIP_PAYMENT_CONFIRM_REQUEST",
    AFIP_PAYMENT_CONFIRM_FAILURE: "afip/AFIP_PAYMENT_CONFIRM_FAILURE",
    AFIP_PAYMENT_CONFIRM_SUCCESS: "afip/AFIP_PAYMENT_CONFIRM_SUCCESS",

    CLEAN_AFIP_TICKET: "afip/CLEAN_AFIP_TICKET",
    AFIP_TICKET_SUCCESS: "afip/EMIT_AFIP_SUCCESS",
    RELATE_BUYER_AFIP_PAYMENT: "afip/RELATE_BUYER_AFIP_PAYMENT",
    SET_AFIP_PAYMENT: "afip/SET_AFIP_PAYMENT",
};

export const INITIAL_STATE = {
    fetching: false,
    afipForms: [],
    afipFields: [],
    afipByCodes: {},
    afipTicket: { status: "", idTransaction: "" },
    afipTaxForm: [],
    afipBarCode: {},
    afipPaymentData: {},
    afipPaymentPrepare: {},
    afipPaymentConfirm: {},
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        afipForms,
        afipFields,
        afipByCodes,
        afipTicket,
        afipTaxForm,
        afipPaymentData,
        afipPaymentPrepare,
        afipPaymentConfirm,
        afipBarCode,
        accounts,
        idTransaction,
    } = action;

    switch (action.type) {
        case types.AFIP_FORM_LIST_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.AFIP_FORM_LIST_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.AFIP_FORM_LIST_SUCCESS:
            return {
                ...state,
                fetching: false,
                afipForms,
            };
        case types.AFIP_FORM_FIELDS_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.AFIP_FORM_FIELDS_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.AFIP_FORM_FIELDS_SUCCESS:
            return {
                ...state,
                fetching: false,
                afipFields,
            };
        case types.AFIP_FORM_FIELDS_CODES_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.AFIP_FORM_FIELDS_CODES_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.AFIP_FORM_FIELDS_CODES_SUCCESS:
            return {
                ...state,
                fetching: false,
                afipByCodes,
            };
        case types.AFIP_TAX_FORMS_REQUEST:
            return {
                ...state,
                fetching: true,
                afipTaxForm: [],
            };
        case types.AFIP_TAX_FORMS_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.AFIP_TAX_FORMS_SUCCESS:
            return {
                ...state,
                fetching: false,
                afipTaxForm,
            };
        case types.AFIP_BAR_CODE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.AFIP_BAR_CODE_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.AFIP_BAR_CODE_SUCCESS:
            return {
                ...state,
                fetching: false,
                afipBarCode,
            };
        case types.AFIP_PAYMENT_PREPARE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.AFIP_PAYMENT_PREPARE_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.AFIP_PAYMENT_PREPARE_SUCCESS:
            return {
                ...state,
                fetching: false,
                afipPaymentPrepare,
            };
        case types.AFIP_PAYMENT_CONFIRM_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.AFIP_PAYMENT_CONFIRM_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.AFIP_PAYMENT_CONFIRM_SUCCESS:
            return {
                ...state,
                fetching: false,
                afipPaymentConfirm,
            };
        case types.AFIP_TICKET_SUCCESS:
            return {
                ...state,
                afipTicket,
            };
        case types.CLEAN_AFIP_TICKET:
            return {
                ...state,
                afipTicket: { status: "", idTransaction: "" },
            };
        case types.SET_AFIP_PAYMENT:
            return {
                ...state,
                afipPaymentData,
            };
        case types.RELATE_BUYER_AFIP_PAYMENT:
            return {
                ...state,
                afipTaxForm,
                afipPaymentData,
                accounts,
                afipBarCode,
                afipPaymentPrepare,
                idTransaction,
            };
        default:
            return state;
    }
};

export const actions = {
    afipFormListReducer: () => ({
        type: types.AFIP_FORM_LIST_REQUEST,
    }),

    afipFormFieldsReducer: (code) => ({
        type: types.AFIP_FORM_FIELDS_REQUEST,
        code,
    }),
    afipFormFieldCodeReducer: (dynamicComboxValues, value, codForm) => ({
        type: types.AFIP_FORM_FIELDS_CODES_REQUEST,
        dynamicComboxValues,
        value,
        codForm,
    }),
    cleanAfipTicket: () => ({
        type: types.CLEAN_AFIP_TICKET,
    }),
    relateBuyerToAfipPayment: (afipPrestacion, setSubmitting) => ({
        type: types.RELATE_BUYER_AFIP_PAYMENT,
        ...afipPrestacion,
        setSubmitting,
    }),
    afipTaxFormsReducer: (codForm, fieldForm) => ({
        type: types.AFIP_TAX_FORMS_REQUEST,
        codForm,
        fieldForm,
    }),
    afipBarCodeGeneratorReducer: (codForm, fieldForm, taxForms, hash) => ({
        type: types.AFIP_BAR_CODE_REQUEST,
        codForm,
        fieldForm,
        taxForms,
        hash,
    }),
    setAfipPaymentData: (afipPaymentData) => ({
        type: types.SET_AFIP_PAYMENT,
        afipPaymentData,
    }),
    afipPaymentPrepareReducer: (codForm, barcode, amount, fieldForm, taxForms, hash) => ({
        type: types.AFIP_PAYMENT_PREPARE_REQUEST,
        codForm,
        barcode,
        amount,
        fieldForm,
        taxForms,
        hash,
    }),
    afipPaymentConfirmReducer: (afipPaymentConfirm, formikBag, credentialType) => {
        gaEventTracker.triggerEvent(events.pagos_servicios_firmar());
        return {
            type: types.AFIP_PAYMENT_CONFIRM_REQUEST,
            afipPaymentConfirm,
            formikBag,
            credentialType,
        };
    },
};

export const selectors = {
    getAfip: ({ afip }) => afip.afip,
};
